"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UiAlert = void 0;
const clsx_1 = __importDefault(require("clsx"));
const react_1 = __importDefault(require("react"));
const __1 = require("../..");
function UiAlert(_a) {
    var _b;
    var { color, icon } = _a, rest = __rest(_a, ["color", "icon"]);
    color = color !== null && color !== void 0 ? color : 'default';
    rest.padding = (_b = rest.padding) !== null && _b !== void 0 ? _b : 2;
    const propsShared = Object.assign(Object.assign({}, rest), { className: clsx_1.default(rest.className, 'UiAlert', `color-${color}`) });
    if (typeof icon === 'boolean') {
        icon =
            {
                success: 'check',
                error: 'error',
                warning: 'warning',
                info: 'info',
            }[color] || null;
    }
    if (icon) {
        return (react_1.default.createElement(__1.UiFlex, Object.assign({}, propsShared, { gap: 2, alignItems: "flex-start" }),
            react_1.default.createElement(__1.UiIconMaterial, { fontSize: 2 }, icon),
            react_1.default.createElement(__1.UiBox, { fullWidth: true },
                react_1.default.createElement("div", null, rest.children))));
    }
    return react_1.default.createElement(__1.UiBox, Object.assign({}, propsShared));
}
exports.UiAlert = UiAlert;
